//create a function that split string by capitalized letters, so ProductNetWeightKg will be split to Product Net Weight Kg
export const splitByCapitalLetters = (str: string) => {
  //so input ProductNetWeightKg would return string Product Net Weight Kg
  return str.replace(/([A-Z])/g, ' $1').trim()
}
